// Library Import
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Local Imports
import ChallengeScreen from "./screens/user/ChallengeScreen";
import TestScreen from "./screens/user/TestScreen";
import AdminLoginScreen from "./screens/admin/AdminLoginScreen";
import AdminDashboard from "./screens/admin/AdminDashoard";
import ForgotPasswordScreen from "./screens/user/ForgotPasswordScreen";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<UserLoginScreen />} /> */}
        <Route path="/" element={<ChallengeScreen />} />
        <Route path="/challenges/:challengeId" element={<TestScreen />} />
        <Route path="/admin" element={<AdminLoginScreen />} />
        <Route path="/adminDash" element={<AdminDashboard />} />
        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
